import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useReservationDefaultIsLocalPaymentAvailable } from "./hooks/use-is-local-payment-available";

export const QuestionReservationDefaultIsLocalPaymentAvailable = () => {
	const { isEdited, hasError, isLocalPaymentAvailable, onSetIsLocalPaymentAvailable } =
		useReservationDefaultIsLocalPaymentAvailable();

	const title = "現地決済を利用可能にする";
	const guide =
		"クレジットカードの登録が済んでいる施設様は、現地決済を選択可能になります。<br />定額チケットを購入していない場合、現地決済の予約手数料がご登録のクレジットカードから引き落とされます。<br />		決済が行えない場合予約が行えません、限度額の設定などにご注意ください。";

	const label = "現地決済を利用可能にする";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<>
					<CheckboxField
						value={isLocalPaymentAvailable.value}
						label={label}
						handleChange={onSetIsLocalPaymentAvailable}
					/>
					<p className="text-sm text-brand">
						予約手数料が従量課金の場合、現地決済の予約手数料についてはご登録のクレジットカードから引き落とされます。
						<br />
						事前にクレジットカードの登録を行ってください。
					</p>
				</>
			}
		/>
	);
};

QuestionReservationDefaultIsLocalPaymentAvailable.displayName = "QuestionReservationDefaultIsLocalPaymentAvailable";
